import { render, staticRenderFns } from "./CreateContentView.vue?vue&type=template&id=6a459a64"
import script from "./CreateContentView.vue?vue&type=script&lang=js"
export * from "./CreateContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports